import { render, staticRenderFns } from "./item-url-field.vue?vue&type=template&id=4bbf4280&scoped=true&"
import script from "./item-url-field.vue?vue&type=script&lang=js&"
export * from "./item-url-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf4280",
  null
  
)

export default component.exports